import React from "react"
import { Layout, Page } from "@shopify/polaris"
import BreadcrumbsOrganism from "views/organisms/commons/breadcrumbs/BreadcrumbsOrganism"
import { useAppContext } from "components/AppContext"
import i18n from "helpers/i18nHelper"

const FakeSimulatePage = () => {
  const { currentPeriod, parentOrganization } = useAppContext()
  const { language: lang } = i18n

  const fakeSimulationImage = () => {
    switch (lang) {
      case "en":
        return "fake-simulation-en.png"
      case "fr":
        return "fake-simulation-fr.png"
      default:
        return "fake-simulation-en.png"
    }
  }

  return (
    <Page fullWidth>
      <Layout>
        <Layout.Section>
          {currentPeriod && (
            <BreadcrumbsOrganism
              parentOrganization={parentOrganization}
              currentPeriodName={currentPeriod?.name}
            />
          )}
        </Layout.Section>

        <Layout.Section>
          <img
            src={require(`assets/images/${fakeSimulationImage()}`)}
            alt=""
            width="100%"
          />
        </Layout.Section>
      </Layout>
    </Page>
  )
}

export default FakeSimulatePage
